import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

function CarouselItem({ imgSrc }) {
    return <div className="item">
        <img className="carousel-img" src={imgSrc} alt="" />
    </div>;
}

function BurCarousel() {
    const [carouselItems, setCarouselItems] = useState([]);

    useEffect(() => {
        const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/carousel`;

        axios.get(apiEndpoint)
            .then(response => setCarouselItems(response.data))
            .catch(error => console.error('Error fetching carousel items:', error));
    }, []);

    return (
        <div id="carousel" className="container-xxl section" style={{ padding: "0px", maxHeight: "200px", overflow: "hidden" }}>
            <div className="container">
                <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    centerMode={false}
                    responsive={responsive}
                    ssr={false} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={3000}
                    keyBoardControl={true}
                    //customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                >
                    {carouselItems.map((item, index) => (
                        <CarouselItem key={item.name+index} imgSrc={process.env.REACT_APP_API_BASE_URL + "/" + item.path} />
                    ))}
                    </Carousel>
            </div>
        </div>
    );
}

export default BurCarousel;

